interface Options {
  renderableFonts: [];
}

const getMetaDataLinks = ({ renderableFonts }: Options) => {
  const links: any = [];
  if (renderableFonts.length > 0) {
    renderableFonts.forEach((font: string) => {
      links.push({
        rel: 'stylesheet',
        href: font,
        tagName: 'link',
      });
    });
  }
  return links;
};

export default getMetaDataLinks;
